import classNames from 'classnames';
import Button from '../atoms/button';
import { useTranslation } from 'react-i18next';

interface ModalConfirmationProps extends React.HTMLAttributes<HTMLDivElement> {
	isModalVisible: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}
const ModalConfirmation = ({
	isModalVisible,
	onConfirm,
	onCancel,
	children,
}: ModalConfirmationProps) => {
	const { t } = useTranslation();
	return (
		<div className="relative">
			<div
				className={classNames(
					'fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-10 transition-opacity',
					{ hidden: !isModalVisible }
				)}
				aria-hidden={!isModalVisible}
			/>
			<div
				className={classNames(
					'bg-white fixed grid gap-4 p-4 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-md shadow-lg max-w-[95%] w-[36rem] max-h-[95%] overflow-auto z-20',
					{
						hidden: !isModalVisible,
					}
				)}
				aria-modal={isModalVisible}
				role="dialog"
			>
				{children}
				<div className="flex justify-around">
					<Button onClick={onConfirm}>{t('misc.confirm')}</Button>
					<Button theme="light" onClick={onCancel}>
						{t('misc.cancel')}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default ModalConfirmation;
